import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from './servicios/supabaseClient';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import './ProductoDetalle.css';
import { obtenerProductoPorId, getPrecioProducto } from './servicios/supabase-funciones';

export default function ProductoDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [producto, setProducto] = useState(null);
  const [precioData, setPrecioData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imagenActualIndex, setImagenActualIndex] = useState(0);
  const [cantidad, setCantidad] = useState(1);
  const [totalCarrito, setTotalCarrito] = useState(0);

  // Cargar producto y precios al montar
  useEffect(() => {
    const cargarProductoYPrecios = async () => {
      try {
        setLoading(true);
        
        // Cargar datos del producto
        const data = await obtenerProductoPorId(id);
        setProducto(data);

        // Cargar información de precios
        try {
          const precioInfo = await getPrecioProducto(id);
          setPrecioData(precioInfo);
        } catch (precioError) {
          console.error('Error cargando precios:', precioError);
          // Si hay error al cargar precios, usar los datos básicos del producto
          setPrecioData({
            precioNormal: data.precio,
            precioOferta: null,
            enOferta: false
          });
        }

        // Restaurar cantidad si ya estaba en carrito
        const carrito = JSON.parse(localStorage.getItem("carrito")) || [];
        const enCarrito = carrito.find(p => p.id === data.id);
        if (enCarrito) setCantidad(enCarrito.cantidad);

      } catch (error) {
        console.error('Error cargando producto:', error);
        setError('Producto no encontrado');
      } finally {
        setLoading(false);
      }
    };

    if (id) cargarProductoYPrecios();
    actualizarContadorCarrito();
  }, [id]);

  // Actualizar contador del carrito
  const actualizarContadorCarrito = () => {
    const carrito = JSON.parse(localStorage.getItem("carrito")) || [];
    const total = carrito.reduce((sum, item) => sum + item.cantidad, 0);
    setTotalCarrito(total);
  };

  const cambiarImagen = (direccion) => {
    if (!producto) return;

    const imagenes = [producto.imagen_url, producto.image_url_2].filter(Boolean);
    if (imagenes.length <= 1) return;

    if (direccion === 'next') {
      setImagenActualIndex((prev) => (prev + 1) % imagenes.length);
    } else {
      setImagenActualIndex((prev) => (prev - 1 + imagenes.length) % imagenes.length);
    }
  };

  const obtenerImagenActual = () => {
    if (!producto) return '';
    const imagenes = [producto.imagen_url, producto.image_url_2].filter(Boolean);
    return imagenes[imagenActualIndex] || imagenes[0] || '';
  };

  const tieneMultiplesImagenes = () => {
    if (!producto) return false;
    return [producto.imagen_url, producto.image_url_2].filter(Boolean).length > 1;
  };

  const añadirAlCarrito = () => {
    if (!producto || !precioData) return;

    // Usar precio de oferta si está disponible, sino precio normal
    const precioFinal = precioData.enOferta && precioData.precioOferta 
      ? precioData.precioOferta 
      : precioData.precioNormal;

    let carrito = JSON.parse(localStorage.getItem("carrito")) || [];
    const existente = carrito.find(p => p.id === producto.id);

    if (existente) {
      existente.cantidad += cantidad;
      existente.precio = precioFinal; // Actualizar precio por si cambió
    } else {
      carrito.push({ 
        id: producto.id, 
        nombre: producto.nombre, 
        precio: precioFinal, 
        cantidad,
        imagen_url: producto.imagen_url 
      });
    }

    localStorage.setItem("carrito", JSON.stringify(carrito));
    actualizarContadorCarrito();
    alert(`✅ ${producto.nombre} x${cantidad} agregado al carrito`);
  };

  const irAlCarrito = () => {
    navigate('/carrito');
  };

  // Componente para mostrar precios
  const PrecioDisplay = () => {
    if (!precioData) {
      return <p className="producto-precio">-</p>;
    }

    const tieneOfertaValida = precioData.enOferta && precioData.precioOferta && precioData.precioOferta > 0;

    if (tieneOfertaValida) {
      return (
        <div className="precios-container-detalle">
          <div className="precio-normal-tachado">
            <span className="precio-original">${precioData.precioNormal}</span>
          </div>
          <div className="precio-oferta-detalle">
            <span className="precio-actual">${precioData.precioOferta}</span>
            <span className="badge-oferta">OFERTA</span>
          </div>
          <div className="descuento-porcentaje">
            {Math.round((1 - precioData.precioOferta / precioData.precioNormal) * 100)}% OFF
          </div>
        </div>
      );
    }

    return (
      <div className="precio-normal-detalle">
        <span className="precio-actual">${precioData.precioNormal}</span>
      </div>
    );
  };

  // Obtener precio para WhatsApp
  const obtenerPrecioWhatsApp = () => {
    if (!precioData) return producto?.precio || 0;
    
    if (precioData.enOferta && precioData.precioOferta) {
      return precioData.precioOferta;
    }
    
    return precioData.precioNormal;
  };

  if (loading) {
    return (
      <div className="producto-detalle-loading">
        <div className="spinner">Cargando...</div>
      </div>
    );
  }

  if (error || !producto) {
    return (
      <div className="producto-detalle-error">
        <h2>Producto no encontrado</h2>
        <button onClick={() => navigate('/')}>Volver al catálogo</button>
      </div>
    );
  }

  const imagenes = [producto.imagen_url, producto.image_url_2].filter(Boolean);
  const precioWhatsApp = obtenerPrecioWhatsApp();

  return (
    <div className="producto-detalle">
      {/* Header */}
      <header className="detalle-header">
        <button className="btn-volver" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faChevronLeft} />
          Volver
        </button>
        
        <h1>Detalle del Producto</h1>
 
      </header>

      {/* Contenido principal */}
      <div className="detalle-contenido">
        {/* Galería de imágenes */}
        <div className="detalle-galeria">
          <div className="imagen-principal">
            <img 
              src={obtenerImagenActual()} 
              alt={producto.nombre}
              className="imagen-producto"
            />
            
            {tieneMultiplesImagenes() && (
              <>
                <button 
                  className="btn-navegacion btn-anterior"
                  onClick={() => cambiarImagen('prev')}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <button 
                  className="btn-navegacion btn-siguiente"
                  onClick={() => cambiarImagen('next')}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
                
                <div className="contador-imagenes">
                  {imagenActualIndex + 1} / {imagenes.length}
                </div>
              </>
            )}
          </div>

          {/* Miniaturas */}
          {imagenes.length > 1 && (
            <div className="miniaturas">
              {imagenes.map((imagen, index) => (
                <button
                  key={index}
                  className={`miniatura ${index === imagenActualIndex ? 'activa' : ''}`}
                  onClick={() => setImagenActualIndex(index)}
                >
                  <img src={imagen} alt={`Vista ${index + 1}`} />
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Información del producto */}
        <div className="detalle-info">
          <div className="producto-header">
            <span className="categoria-badge">{producto.categoria}</span>
            <h1 className="producto-titulo">{producto.nombre}</h1>
            <PrecioDisplay />
          </div>

          <div className="producto-descripcion">
            <h3>Descripción</h3>
            <p>{producto.detalle || 'Descripción no disponible'}</p>
            <p>{producto.descripcion || 'Descripción no disponible'}</p>
          </div>

          <div className="producto-stock">
            <span className={`stock ${producto.stock > 5 ? 'disponible' : 'limitado'}`}>
              {producto.stock > 5 ? '✅ En stock' : '⚠️ Últimas unidades'}
            </span>
          </div>

          {/* Selector de cantidad */}
          <div className="selector-cantidad">
            <label>Cantidad:</label>
            <div className="controles-cantidad">
              <button 
                onClick={() => setCantidad(prev => Math.max(1, prev - 1))}
                disabled={cantidad <= 1}
              >
                -
              </button>
              <span>{cantidad}</span>
              <button 
                onClick={() => setCantidad(prev => prev + 1)}
                disabled={producto.stock <= cantidad}
              >
                +
              </button>
            </div>
          </div>

          {/* Botones de acción */}
          <div className="botones-accion">
          
            
            <a
              href={`https://wa.me/5493426126862?text=Hola, me interesa el producto: ${encodeURIComponent(producto.nombre)} (${producto.categoria}) - Precio: $${precioWhatsApp} con una cantidad de ${cantidad}.`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
              Consultar por WhatsApp
            </a>
          </div>

          {/* Información adicional */}
          <div className="info-adicional">
            <div className="info-item">
              <strong>Categoría:</strong> {producto.categoria}
            </div>
            <div className="info-item">
              <strong>Stock disponible:</strong> {producto.stock} unidades
            </div>
            {precioData?.enOferta && (
              <div className="info-item oferta-info">
                <strong>¡Oferta especial!</strong> Aprovecha el descuento
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}